import { render, staticRenderFns } from "./LinkForm.vue?vue&type=template&id=a3005f9c"
import script from "./LinkForm.vue?vue&type=script&lang=js"
export * from "./LinkForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports